import { ComponentChild } from 'preact';
import { useState } from 'preact/hooks';
import { useTooltipControlled } from '../hooks/UNSAFE_useTooltip';

type Props = {
  label: string;
  isDisabled: boolean;
};

export const useTabBarItemTooltip = ({
  label,
  isDisabled
}: Props): {
  tooltipContent: ComponentChild;
  tooltipEventHandlerProps: Record<string, any>;
  onLogicalFocus: (elem: HTMLElement) => void;
  onLogicalBlur: () => void;
} => {
  const [isOpen, setOpen] = useState<boolean>(false);
  const { tooltipProps, tooltipContent } = useTooltipControlled({
    isOpen: isOpen,
    isDisabled,
    focusStrategy: 'logical',
    text: label,
    onToggle: ({ value }) => {
      setOpen(value);
    }
  });
  const { onLogicalFocus, onLogicalBlur, ...tooltipEventHandlerProps } = tooltipProps;

  return { tooltipContent, tooltipEventHandlerProps, onLogicalFocus, onLogicalBlur };
};
